import { render, staticRenderFns } from "./customer.vue?vue&type=template&id=8b7589a6&scoped=true"
import script from "./customer.vue?vue&type=script&lang=js"
export * from "./customer.vue?vue&type=script&lang=js"
import style0 from "./customer.vue?vue&type=style&index=0&id=8b7589a6&prod&lang=css"
import style1 from "./customer.vue?vue&type=style&index=1&id=8b7589a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b7589a6",
  null
  
)

export default component.exports